import * as i0 from '@angular/core';
import * as i1 from './autocomplete.module';
import * as i2 from '@angular/common';
import * as i3 from '@angular/forms';
import * as i4 from '@vltansky/ng-select';
import * as i5 from '@ng-select/ng-option-highlight';
import * as i6 from './autocomplete.component';
export const BllAutocompleteModuleNgFactory:i0.NgModuleFactory<i1.BllAutocompleteModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any,any> = (<any>(null as any));
var _decl0_3:i2.NgIf<any> = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.ɵangular_packages_forms_forms_ba = (<any>(null as any));
var _decl0_12:i3.NgSelectOption = (<any>(null as any));
var _decl0_13:i3.ɵangular_packages_forms_forms_z = (<any>(null as any));
var _decl0_14:i3.DefaultValueAccessor = (<any>(null as any));
var _decl0_15:i3.NumberValueAccessor = (<any>(null as any));
var _decl0_16:i3.RangeValueAccessor = (<any>(null as any));
var _decl0_17:i3.CheckboxControlValueAccessor = (<any>(null as any));
var _decl0_18:i3.SelectControlValueAccessor = (<any>(null as any));
var _decl0_19:i3.SelectMultipleControlValueAccessor = (<any>(null as any));
var _decl0_20:i3.RadioControlValueAccessor = (<any>(null as any));
var _decl0_21:i3.NgControlStatus = (<any>(null as any));
var _decl0_22:i3.NgControlStatusGroup = (<any>(null as any));
var _decl0_23:i3.RequiredValidator = (<any>(null as any));
var _decl0_24:i3.MinLengthValidator = (<any>(null as any));
var _decl0_25:i3.MaxLengthValidator = (<any>(null as any));
var _decl0_26:i3.PatternValidator = (<any>(null as any));
var _decl0_27:i3.CheckboxRequiredValidator = (<any>(null as any));
var _decl0_28:i3.EmailValidator = (<any>(null as any));
var _decl0_29:i3.NgModel = (<any>(null as any));
var _decl0_30:i3.NgModelGroup = (<any>(null as any));
var _decl0_31:i3.NgForm = (<any>(null as any));
var _decl0_32:i3.FormControlDirective = (<any>(null as any));
var _decl0_33:i3.FormGroupDirective = (<any>(null as any));
var _decl0_34:i3.FormControlName = (<any>(null as any));
var _decl0_35:i3.FormGroupName = (<any>(null as any));
var _decl0_36:i3.FormArrayName = (<any>(null as any));
var _decl0_37:i4.NgSelectComponent = (<any>(null as any));
var _decl0_38:i4.ɵr = (<any>(null as any));
var _decl0_39:i4.ɵg = (<any>(null as any));
var _decl0_40:i4.ɵf = (<any>(null as any));
var _decl0_41:i4.ɵh = (<any>(null as any));
var _decl0_42:i4.ɵi = (<any>(null as any));
var _decl0_43:i4.ɵj = (<any>(null as any));
var _decl0_44:i4.ɵk = (<any>(null as any));
var _decl0_45:i4.ɵl = (<any>(null as any));
var _decl0_46:i4.ɵm = (<any>(null as any));
var _decl0_47:i4.ɵn = (<any>(null as any));
var _decl0_48:i4.ɵo = (<any>(null as any));
var _decl0_49:i4.ɵp = (<any>(null as any));
var _decl0_50:i5.NgOptionHighlightDirective = (<any>(null as any));
var _decl0_51:i6.BllAutocompleteComponent = (<any>(null as any));
var _decl0_52:i2.AsyncPipe = (<any>(null as any));
var _decl0_53:i2.UpperCasePipe = (<any>(null as any));
var _decl0_54:i2.LowerCasePipe = (<any>(null as any));
var _decl0_55:i2.JsonPipe = (<any>(null as any));
var _decl0_56:i2.SlicePipe = (<any>(null as any));
var _decl0_57:i2.DecimalPipe = (<any>(null as any));
var _decl0_58:i2.PercentPipe = (<any>(null as any));
var _decl0_59:i2.TitleCasePipe = (<any>(null as any));
var _decl0_60:i2.CurrencyPipe = (<any>(null as any));
var _decl0_61:i2.DatePipe = (<any>(null as any));
var _decl0_62:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_63:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_64:i2.KeyValuePipe = (<any>(null as any));
var _decl0_65:i2.CommonModule = (<any>(null as any));
var _decl0_66:i3.FormsModule = (<any>(null as any));
var _decl0_67:i3.ReactiveFormsModule = (<any>(null as any));
var _decl0_68:i4.NgSelectModule = (<any>(null as any));
var _decl0_69:i5.NgOptionHighlightModule = (<any>(null as any));
var _decl0_70:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_71:i0.ElementRef<any> = (<any>(null as any));
function _View_BllAutocompleteComponent_Host_1_0():void {
  var _any:any = (null as any);
}
function _View_BllAutocompleteComponent_1_2():void {
  var _any:any = (null as any);
  const currVal_0:any = _any[_any];
  currVal_0;
}
function _View_BllAutocompleteComponent_1_1():void {
  var _any:any = (null as any);
  const currVal_0:any = _any;
  currVal_0;
  const currVal_1:any = _any[_decl0_51.bindLabel];
  currVal_1;
  const currVal_2:any = _decl0_51.extraLabels;
  currVal_2;
}
function _View_BllAutocompleteComponent_1_3():void {
  if ((_decl0_51.errorMsg || _decl0_51.placeholder)) {
    var _any:any = (null as any);
    const currVal_0:any = (_decl0_51.errorMsg || _decl0_51.placeholder);
    currVal_0;
  }
}
function _View_BllAutocompleteComponent_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_51.bindLabel;
  currVal_0;
  const currVal_1:any = _decl0_51.bindValue;
  currVal_1;
  const currVal_2:any = _decl0_51.placeholder;
  currVal_2;
  const currVal_3:any = _decl0_51.notFoundText;
  currVal_3;
  const currVal_4:any = _decl0_51.typeToSearchText;
  currVal_4;
  const currVal_5:any = _decl0_51.loadingText;
  currVal_5;
  const currVal_6:any = _decl0_51.loading;
  currVal_6;
  const currVal_7:any = _decl0_51.disabled;
  currVal_7;
  const currVal_8:any = _decl0_51.minTermLength;
  currVal_8;
  const currVal_9:any = false;
  currVal_9;
  const currVal_10:any = _decl0_51.typeahead;
  currVal_10;
  const currVal_11:any = _decl0_51.searchable;
  currVal_11;
  const currVal_12:any = _decl0_51.clearable;
  currVal_12;
  const currVal_13:any = _decl0_51.items;
  currVal_13;
  const currVal_14:any = _decl0_37.useDefaultClass;
  currVal_14;
  const currVal_15:any = !_decl0_37.multiple;
  currVal_15;
  const currVal_16:any = _decl0_37.typeahead;
  currVal_16;
  const currVal_17:any = _decl0_37.multiple;
  currVal_17;
  const currVal_18:any = _decl0_37.addTag;
  currVal_18;
  const currVal_19:any = _decl0_37.searchable;
  currVal_19;
  const currVal_20:any = _decl0_37.clearable;
  currVal_20;
  const currVal_21:any = _decl0_37.isOpen;
  currVal_21;
  const currVal_22:any = _decl0_37.disabled;
  currVal_22;
  const currVal_23:any = _decl0_37.filtered;
  currVal_23;
  const currVal_24:any = _decl0_51.selected;
  currVal_24;
  const currVal_25:any = _decl0_21.is('untouched');
  currVal_25;
  const currVal_26:any = _decl0_21.is('touched');
  currVal_26;
  const currVal_27:any = _decl0_21.is('pristine');
  currVal_27;
  const currVal_28:any = _decl0_21.is('dirty');
  currVal_28;
  const currVal_29:any = _decl0_21.is('valid');
  currVal_29;
  const currVal_30:any = _decl0_21.is('invalid');
  currVal_30;
  const currVal_31:any = _decl0_21.is('pending');
  currVal_31;
  const currVal_32:any = _decl0_51.isEnglish;
  currVal_32;
  const currVal_33:any = _decl0_51.extraLabels;
  currVal_33;
  const currVal_34:any = (_decl0_51.errorMsg || _decl0_51.placeholder);
  currVal_34;
  const pd_35:any = ((<any>_decl0_37.handleKeyDown(_any)) !== false);
  const pd_36:any = ((<any>(_decl0_51.selected = _any)) !== false);
  const pd_37:any = ((<any>_decl0_51.onChange(_any)) !== false);
}
